import { z } from "zod";
import { AgencyIdSchema, ProjectIdSchema, RunIdSchema } from "../primitives/ids.js";
import { ArtifactEntryV1Schema } from "./artifact-entry.js";
import { ArtifactSetV1Schema } from "./artifact-set.js";
import { BuildManifestV1Schema } from "./build-manifest.js";
/** quality-input-bundle.v1.0 — Quality Gate input; no surface-engine import required */
export const QualityInputBundleV1Schema = z
    .object({
    schemaVersion: z.literal("quality-input-bundle.v1.0"),
    agencyId: AgencyIdSchema,
    projectId: ProjectIdSchema,
    runId: RunIdSchema,
    artifactSet: ArtifactSetV1Schema,
    buildManifest: BuildManifestV1Schema,
    artifactEntries: z.array(ArtifactEntryV1Schema).min(1),
})
    .strict();
//# sourceMappingURL=quality-input-bundle.js.map